import config from 'local_modules/app-config'
import getCityName from './getCityName'

const currentCity = (window && window.location && getCityName({ host: window.location.host })) || ''
const isKurchatov = currentCity === 'kurchatov'
const isTest = config.api === 'test' || config.env === 'development'

const testAreas   = { mc: 1, ikar: 4, ip: 7 }
const prodAreas   = { mc: 1, ikar: 14, ip: 18, bc: 13 }

const areas = isTest ? testAreas : prodAreas

const testTools = isKurchatov ? {
  gym: 1,
  rink: 3,
} : {
  // banyaLux: 6,
  // banya: 16,
  sauna: 4,
  pool: 1,
  gym: 2,
  tennis: 3,
  rink: 5,
  tramp: 7,
  mfc: 6,
}

const prodTools = isKurchatov ? {
  gym: 1,
  rink: 3,
} : {
  // banyaLux: 6,
  // banya: 16,
  sauna: 4,
  pool: 1,
  gym: 2,
  tennis: 3,
  rink: 6,
  tramp: 7,
  mfc: 5,
}

const tools = isTest ? testTools : prodTools


export default {
  areas,
  tools,
}